<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="appointmentOrders"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button type="primary" :loading="addSalesOrderLoading" :disabled="!selection.length" @click="addSalesOrderHandle"> 新增借项订单 </el-button>
        <el-button type="primary" :loading="addSalesOrderLoading" :disabled="!selection.length" @click="addSalesOrderHandle"> 数据分析 </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入单号" clearable/>
          </el-form-item>
          <el-form-item label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" placeholder="请输入出厂编号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="销售员">
            <el-input v-model.trim="filter.salesmanName" placeholder="请输入销售员" clearable/>
          </el-form-item>
          <el-form-item label="现场联系方式">
            <el-input v-model.trim="filter.siteMobile" placeholder="请输入现场联系方式" clearable/>
          </el-form-item>
          <el-form-item label="服务地址">
            <el-input v-model.trim="filter.serviceAddress" placeholder="请输入服务地址" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </viewTable>
    <appointment-edit ref="appointmentEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import AppointmentEdit from "@/views/AfterSaleManage/AppointmentOrder/AppointmentEdit";
  export default {
    name: "AppointmentOrder",
    components: {AppointmentEdit, viewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(632),
          editAuth: this.$auth(633),
          delAuth: this.$auth(634),
          subAuth: this.$auth(705),
        },
        submitLoading: false,
        addSalesOrderLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/Appointment",
                        query: {
                          billType: 15,
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            key: "factoryNo",
            align: "center",
            width: 120,
          },
          {
            key: "creatTime",
            align: "center",
            width: 160,
          },
          {
            key: "customerName",
            align: "center",
            width: 210,
          },
          {
            key: "contact",
            align: "center",
            width: 80,
          },
          {
            key: "serviceAddress",
            minWidth: 160,
            tooltip: true,
          },
          {
            key: "siteMobile",
            width: 160,
          },
          {
            key: "salesmanName",
            width: 140,
            align: "center",
          },
          {
            key: "nodeDesc",
            width: 140,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.appointmentEdit.open(row);
      },
      addSalesOrderHandle() {
        if (this.selection.length > 1) {
          this.$confirm("请选择一条服务申请单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.addSalesOrderLoading = true;
        let id = this.selection[0].pkid;
        this.$http.get("basic", `appointmentOrders/addSalesOrderHandle/${id}`).then((resp) => {
          if (resp.success) {
            this.$message.success("操作成功");
            this.addSalesOrderLoading = false;
            this.loadData();
          }
        }).catch(() => {
          this.addSalesOrderLoading = false;
        });
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `appointmentOrders/submit/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "appointmentOrders", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
